import React, { useEffect, useState } from 'react';
import {
  BtnElements,
  CallMeBtn,
  CallMeBtnText,
  CallMeBtnWrapper,
  CallMeFooterContainer,
  CallMeInfoWrapper,
  CallMeTextInfo,
  FooterImageBanner,
  FooterImagesContainer,
  FooterOverlay,
  LegalFooterContainer,
  LegalFooterLink,
  MainContainer,
  MobileFooterImage,
  MobileFooterImageContainer,
  Phone,
} from './FooterStyledComponents';
import { ROUTES_PATH } from '../../constants';
import {
  MobileOnly,
  TextBold,
  TextRegular,
} from '../../styles/GlobalStyledComponents';
import { PhonesEnum } from '../../interfaces/Phones';
import { colors } from '../../styles/Colors';
import IconPhoneBold from '../../assets/icons/IconPhoneBold';
import ClickToCallModal from '../ClickToCallModal/ClickToCallModal';
import FooterImageSVG from '../../assets/images/Background/ImgMobileFooter.webp';
import ImageApple from '../../assets/images/Background/Buttons/apple_button.svg';
import ImageGoogle from '../../assets/images/Background/Buttons/google_button.svg';
import { ViewMode } from '../../interfaces/Mode';
import { MobileModal } from '../ModalMobile/MobileModal';
import { useCardsResult } from '../../contexts/CardsContext';
import { useDebtResult } from '../../contexts/DebtContext';
import { usePaymentSelected } from '../../contexts/PaymentSelectedContext';
interface FooterProps {
  viewMode: ViewMode | null;
}
export const Footer = ({ viewMode }: FooterProps) => {
  const { cardsResult } = useCardsResult();
  const { debtResult } = useDebtResult();
  const { coPaymentSelected } = usePaymentSelected();
  const [modalOpened, setmodalOpened] = useState<boolean>(false);
  const [modalSuccessOpened, setmodalSuccessOpened] = useState<boolean>(false);
  const [marginBottom, setMarginBottom] = useState<string>('');
  const flowCO = sessionStorage.getItem('flow') === 'co';
  const advancedFee = JSON.parse(
    sessionStorage.getItem('advance-fee') ?? 'false'
  );
  const [mobile_number, setMobileNumber] = useState<string>();

  const IOS_DOWNLOAD_LINK =
    'https://apps.apple.com/es/app/pepper-clientes/id6503949540';
  const ANDROID_DOWNLOAD_LINK =
    'https://play.google.com/store/apps/details?id=com.pepperfinance.clients';

  // Compruebo si es una ruta que tiene botones de navegación para ajustar el margin bottom en dispositivos móviles
  const navigationButtonsPath = () => {
    // Solo se añade como excepción CO si hay tarjetas guardadas y el cliente tiene una única operación
    const CoException =
      (flowCO &&
        cardsResult &&
        cardsResult.payment_methods.length > 0 &&
        debtResult &&
        debtResult.loans.length === 1 &&
        !coPaymentSelected) ||
      (flowCO && debtResult && debtResult.loans.length > 1 && coPaymentSelected)
        ? true
        : false;
    if (
      window.location.pathname === ROUTES_PATH.ENTRY ||
      (window.location.pathname.includes(ROUTES_PATH.TYPES_PAYMENTS) &&
        !advancedFee) ||
      (CoException && window.location.pathname.includes(ROUTES_PATH.ENTRY_CO)) && 
      !window.location.pathname.includes(ROUTES_PATH.SUCCESS) &&
      !window.location.pathname.includes(ROUTES_PATH.NO_DEBT)
    ) {
      setMarginBottom('170');
    } else if (
      (!window.location.pathname.includes(ROUTES_PATH.NO_DEBT) &&
        window.location.pathname.includes(ROUTES_PATH.TYPES_PAYMENTS) &&
        advancedFee) ||
      window.location.pathname.includes(ROUTES_PATH.TPV) ||
      window.location.pathname.includes(ROUTES_PATH.ENTRY_CO)
    ) {
      setMarginBottom('96');
    } else {
      setMarginBottom('0');
    }
  };

  useEffect(() => {
    navigationButtonsPath();
  }, [window.location.pathname, cardsResult, coPaymentSelected]);

  return (
    <>
      <FooterOverlay
        open={modalOpened}
        onClick={(e: any) => {
          setmodalOpened(false);
        }}
        id="footer-call-me-background"
      />
      <FooterOverlay
        open={modalSuccessOpened}
        onClick={(e: any) => {
          setmodalSuccessOpened(false);
        }}
        id="footer-call-me-background"
      />
      <MainContainer id="footer-container" $marginBottom={marginBottom}>
        <CallMeFooterContainer id="call-me-footer">
          <CallMeInfoWrapper id="call-me-info-wrapper">
            <CallMeTextInfo id="call-me-text-info">
              <TextBold fontSize={16}>Te llamamos si tienes dudas</TextBold>
              <TextRegular
                fontSize={14}
                fontWeight={500}
                color="gray6"
                lineHeight={22}
              >
                O si lo prefieres, llámanos al&nbsp;
                <Phone
                  href={`tel:+34${
                    flowCO ? PhonesEnum.SUPPORT_PHONE_CO : PhonesEnum.SUPPORT_PHONE
                  }`}
                  id="call-me-phone-link"
                >
                  {flowCO
                    ? PhonesEnum.SUPPORT_PHONE_CO_FORMATTED
                    : PhonesEnum.SUPPORT_PHONE_FORMATTED}
                </Phone>
              </TextRegular>
            </CallMeTextInfo>
          </CallMeInfoWrapper>
          <CallMeBtnWrapper id="call-me-btn-wrapper">
            <CallMeBtn
              id="call-me-btn"
              onClick={(e: any) => {
                setmodalOpened(true);
              }}
              backgroundColor={`${colors.green2}`}
              color={`${colors.white}`}
              fontWeight={700}
            >
              <BtnElements id="call-me-btn-elements">
                <IconPhoneBold />
                <CallMeBtnText fontSize={18} color="white">
                  ¿Te llamamos?
                </CallMeBtnText>
              </BtnElements>
            </CallMeBtn>
          </CallMeBtnWrapper>
        </CallMeFooterContainer>
        {viewMode !== ViewMode.APP && (
          <MobileFooterImageContainer id="mobile-image-footer">
            <MobileOnly>
              <picture>
                <source srcSet={FooterImageSVG} media="(max-width: 850px)" />
                <MobileFooterImage
                  src={FooterImageSVG}
                  alt="Pepper Mobile App"
                  id="mobile-image-footer-img"
                  width={'100%'}
                  height={'100%'}
                  loading="lazy"
                  title="Pepper Mobile App"
                />
              </picture>
            </MobileOnly>

            <FooterImagesContainer id="footer-images-container">
              <MobileOnly>
                <picture>
                  <source srcSet={ImageApple} media="(max-width: 850px)" />
                  <FooterImageBanner
                    src={ImageApple}
                    alt="Image Apple"
                    width="100%"
                    height="100%"
                    title="Descargar en App Store"
                    id="banner-mobile-img"
                    loading="lazy"
                    onClick={() =>
                      window.open(
                        process.env.IOS_DOWNLOAD_LINK ?? IOS_DOWNLOAD_LINK
                      )
                    }
                  />
                </picture>
              </MobileOnly>
              <MobileOnly>
                <picture>
                  <source srcSet={ImageGoogle} media="(max-width: 850px)" />
                  <FooterImageBanner
                    src={ImageGoogle}
                    alt="Image Google"
                    width="100%"
                    height="100%"
                    title="Descargar en Google Play"
                    id="banner-mobile-img"
                    loading="lazy"
                    onClick={() =>
                      window.open(
                        process.env.ANDROID_DOWNLOAD_LINK ??
                          ANDROID_DOWNLOAD_LINK
                      )
                    }
                  />
                </picture>
              </MobileOnly>
            </FooterImagesContainer>
          </MobileFooterImageContainer>
        )}
        <LegalFooterContainer id="legal-footer">
          <LegalFooterLink href={ROUTES_PATH.LEGAL_NOTICE} target="_blank">
            Aviso legal y condiciones de uso
          </LegalFooterLink>
          <LegalFooterLink href={ROUTES_PATH.PRIVACY_POLICY} target="_blank">
            Privacidad
          </LegalFooterLink>
          <LegalFooterLink href={ROUTES_PATH.COOKIES_POLICY} target="_blank">
            Política de Cookies
          </LegalFooterLink>
        </LegalFooterContainer>
      </MainContainer>

      {modalOpened && (
        <ClickToCallModal
          close={() => setmodalOpened(false)}
          modalSuccess={(mobileNumber: string) => {
            setmodalSuccessOpened(true);
            setMobileNumber(mobileNumber);
          }}
        />
      )}
      {modalSuccessOpened && (
        <MobileModal
          close={() => setmodalSuccessOpened(false)}
          mobile_number={mobile_number!}
        />
      )}
    </>
  );
};
